/** @format */
import { FinnishAddress, GenericAddress } from 'common-typescript/types';

export function isFinnishAddress(address: any): address is FinnishAddress {
    return address?.type === 'FinnishAddress';
}

export function isGenericAddress(address: any): address is GenericAddress {
    return address?.type === 'GenericAddress';
}
